export default __webpack_public_path__ + "b82e9fed24305fba3105ef6a6e714dc7.png";